import type { FeatureModule } from '@/shell/registry/types'

export default {
  code: 'cloudpc',
  title: '云电脑',
  routes: [
    { path: '/cloud-pc', name: 'cloudpc', component: () => import('./CloudPcView.vue'), meta: {} },
  ],
} satisfies FeatureModule
